import { render } from "./ShippingView.vue?vue&type=template&id=f159a422&scoped=true"
const script = {}

import "./ShippingView.vue?vue&type=style&index=0&id=f159a422&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f159a422"]])

export default __exports__